import { render, staticRenderFns } from "./headerTextBg.vue?vue&type=template&id=23783a49&scoped=true"
import script from "./headerTextBg.vue?vue&type=script&lang=js"
export * from "./headerTextBg.vue?vue&type=script&lang=js"
import style0 from "./headerTextBg.vue?vue&type=style&index=0&id=23783a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23783a49",
  null
  
)

export default component.exports